import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import { Tooltip } from 'framework/ui/mui-builder';
import PositionSlotValidationErrorsTooltip from 'domain/people/positionSlots/field/PositionSlotValidationErrorsTooltip';
import type { PreviewPositionSlotListItem } from '../../types';
import { buildSecondaryCompetencyLabel } from '../utils/secondaryCompetencyLabel';

const SecondaryCompetenciesTooltip = ({ positionSlot }: { positionSlot: PreviewPositionSlotListItem }) => {
  if (!positionSlot.secondaryCompetencyItems?.length) {
    return null;
  }

  return (
    <Tooltip
      title={
        <PositionSlotValidationErrorsTooltip
          errors={positionSlot.secondaryCompetencyItems.map(buildSecondaryCompetencyLabel)}
        />
      }
    >
      <LayersOutlinedIcon color="action" fontSize="small" aria-label="Hybrid position" />
    </Tooltip>
  );
};

export default SecondaryCompetenciesTooltip;
